import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// Styled components
const NoResultsWrap = styled.div`
  display: flex;
  width: 100%;
  height: 90vh;
  flex-direction: column;
`;
const ErrorWrap = styled.div`
  margin: auto;
  font-size: 18px;
  text-align: center;
  padding: 15px;
`;
const ErrorText = styled.div`
  font-weight: 600;
  text-align: center;
  color: red;
  margin-bottom: 15px;
`;

let NoResults = ({ error }) => (
  <NoResultsWrap>
    <ErrorWrap>
      <ErrorText>
        {error ? error : "There are no results for your search"}
      </ErrorText>
      <div>
        <Link to="/">Please retry your search.</Link>
      </div>
    </ErrorWrap>
  </NoResultsWrap>
);

export default NoResults;



// WEBPACK FOOTER //
// ./src/scenes/SearchResultsPage/components/NoResults/index.js